<div class="container-fluid">

  <h4 id="upper">Demandes de locations </h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">

          <div class="row mb-md-2">
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <!-- Filtres alignés à gauche -->
              <div>
                <label class="d-inline-flex align-items-center">
                  DE :
                  <input style="width: 200px;" type="date" [(ngModel)]="dateDebut" name="dateDebut"
                    class="form-control form-control-sm ms-2" aria-controls="tickets-table" />
                </label>
              </div>
              <div>
                <label class="d-inline-flex align-items-center">
                  A :
                  <input style="width: 200px;" type="date" [(ngModel)]="dateFin" name="dateFin"
                    class="form-control form-control-sm ms-2" aria-controls="tickets-table" />
                </label>
              </div>
              <label for="categorie" class="form-label">Statut</label>
              <div>

                <label class="d-inline-flex align-items-center">

                  <select [(ngModel)]="statut" name="statut" class="form-select" id="categorie">
                    <option selected>Choisir un statut</option>
                    <option value="En attente"> En attente</option>
                    <option value="Valide"> Valide</option>
                  </select>
                </label>
              </div>

              <!-- Boutons alignés à gauche, côte à côte -->
              <div class="d-inline-flex align-items-center">
                <button (click)="searchByPeriode()" id="gras" style="width: 150px; height: 40px;" type="button"
                  class="btn btn-primary btn-sm">
                  Rechercher
                </button>
              </div>
              <div class="d-flex">
                <div class="ms-auto">
                  <button id="gras"
                    style="background-color: #1C602B; height: 40px; display: flex; justify-content: center; align-items: center; gap: 8px; color: white;"
                    type="button" class="btn btn-primary btn-sm" (click)="newLocation()">
                    Nouvelle demande <i class=" ri-add-circle-line font-size-18"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col" class="ps-0">Période de location</th>
                  <th scope="col" class="text-center">Cooperative</th>
                  <th scope="col" class="text-center">Status</th>
                  <th scope="col" colspan="2" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems">
                  <th scope="row" class="ps-0 fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.date_debut |dateFormat }} au
                      {{item.date_fin|dateFormat }} &nbsp;
                    </span>
                  </th>

                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item?.membre.cooperative?.nom}}</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{item.statut}} &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <a (click)="openModal(item)" title="" style="cursor: pointer;" class="me-3 text-primary"
                      v-b-tooltip.hover title="Cliquez ici pour voir plus de détails">
                      Détails &nbsp;&nbsp; <i class="ri-eye-fill font-size-18"></i>
                    </a>

                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>

           <div class="d-flex justify-content-center mt-4" *ngIf="isLoading === true">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Chargement en cours...</h5>
                                <div class="loader4"></div>
                            </div>
                        </div>
                    </div>
                </div>
        <div *ngIf="hasError && !isLoading" class="text-center my-5">
          <i class="bi bi-exclamation-circle text-danger" style="font-size: 2rem;"></i>
          <p class="text-danger">{{ errorMessage }}</p>
          <button class="btn btn-primary" (click)="getDemandeLocation()"><i class="pi pi-refresh"
              style="font-size: 2rem"></i>
          </button>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center mt-4">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>


</div>
<ng-template #modalContent1 let-modal>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
  </div>
  <div class="modal-body">
    <div class="container">
      <!-- Informations du Bon -->
      <div class="card mb-4">
        <div class="card-header bg-success text-white">
          <h4 id="upper" class="text-center">Informations </h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6"><strong>Référence :</strong> <span class="text-muted">{{ detailsItems.reference }}</span>
            </div>
            <div class="col-6"><strong>Statut :</strong> <span class="badge bg-warning text-dark">{{ detailsItems.statut
                | titlecase }}</span></div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Date de Début :</strong> <span class="text-muted">{{ detailsItems.date_debut |
                date: 'dd MMM yyyy' }}</span></div>
            <div class="col-6"><strong>Date de Fin :</strong> <span class="text-muted">{{ detailsItems.date_fin | date:
                'dd MMM yyyy' }}</span></div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Quantité :</strong> <span class="text-muted">{{ detailsItems.quantite }}</span>
            </div>
            <div class="col-6"><strong>Montant Total :</strong> <span class="text-muted">{{ detailsItems.montant_total |
                currency: 'CFA ' }}</span></div>
          </div>
        </div>
      </div>

      <!-- Informations de la Machine -->
      <div class="card mb-4">
        <div class="card-header bg-primary text-white">
          <h4 id="upper" class="text-center">Informations de la Machine</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6"><strong>Nom :</strong> <span class="text-muted">{{ detailsItems.machine.nom }}</span>
            </div>
            <div class="col-6"><strong>Numéro de Série :</strong> <span class="text-muted">{{
                detailsItems.machine.numero_serie }}</span></div>
          </div>
          <div class="row">
            <div class="col-6"><strong>Condition :</strong> <span class="badge bg-success">{{
                detailsItems.machine.condition_location | uppercase }}</span></div>
            <div class="col-6"><strong>Type de Maintenance :</strong> <span class="text-muted">{{
                detailsItems.machine.type_maintenance }}</span></div>
          </div>
          <div class="row">
            <div class="col-12"><strong>Montant :</strong> <span class="text-muted">{{ detailsItems.machine.montant |
                currency: 'CFA ' }}</span></div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <img [src]="detailsItems.machine.image" alt="Image Machine" class="img-fluid rounded shadow-sm" />
            </div>
          </div>
        </div>
      </div>

      <!-- Informations de la Coopérative -->
      <div class="card mb-4">
        <div class="card-header bg-warning text-dark">
          <h4 id="upper" class="text-center">Informations de la Coopérative</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6"><strong>Nom :</strong> <span class="text-muted">{{ detailsItems.membre.cooperative.nom
                }}</span></div>
            <div class="col-6"><strong>Localisation :</strong> <span class="text-muted">{{
                detailsItems.membre.cooperative.localisation }}</span></div>
          </div>
          <div class="row">
            <div class="col-12"><strong>Description :</strong> <span class="text-muted">{{
                detailsItems.membre.cooperative.description }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>


</ng-template>
<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>